
import Vue from 'vue';

interface InputSecurityData {
  // List of the key or PIN will be held
  currentKey: string[];
  // Current index of the input must be.
  // Prevent user to access another index of PIN.
  currentFocusIndex: number;
}

interface InputSecurityMethods {
  // Callback when user input the PIN
  handleInput(event: any, index: number): void;
  // Callback to prevent user to access another index of PIN
  handleFocus(event: any, index: number): void;
  // Callback when user want to delete the PIN number
  handleDelete(index: number): void;
  // Utility for focus the input
  doFocusRef(index: number): boolean;
  // Computed value for input
  inputSecurityClasses(index: number): any;
}

interface InputSecurityComputed {
  // The string will be thrown to the parent.
  combinedKey: string;
}

interface InputSecurityProps {
  length: number;
  securityKey: string;
  disableMask: boolean;
}

/**
 * Input Security / PIN
 *
 * The collection of 1 digit input to a string of PIN.
 */
export default Vue.extend<InputSecurityData, InputSecurityMethods, InputSecurityComputed, InputSecurityProps>({
  name: 'InputSecurity',
  model: {
    prop: 'securityKey'
  },
  props: {
    /**
     * The length of the PIN. Default is 6.
     */
    length: {
      type: Number,
      default: 6
    },
    /**
     * Security key will thrown to the parent.
     * When using v-model the props will be ignored.
     */
    securityKey: {
      type: String,
      required: true
    },
    /**
     * The mask will be disabled
     */
    disableMask: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentKey: [],
      currentFocusIndex: 0
    };
  },
  computed: {
    combinedKey() {
      return this.currentKey.join('');
    }
  },
  methods: {
    handleInput(event: any, index: number) {
      const currentKey = [...this.currentKey];
      const value = parseInt(event.target.value, 10);

      // Need validate when over than 1 digit
      if (0 <= value && value <= 9) {
        currentKey[index] = value.toString();
        this.currentFocusIndex = index + 1 === this.length ? index : index + 1;

        if (!this.doFocusRef(index + 1)) {
          event.target.blur();
        }
      }

      this.currentKey = currentKey;
      /**
       * Handle when the input value change.
       * @event input
       * @type {function}
       */
      this.$emit('input', this.combinedKey);
    },
    handleFocus(event: any, index: number) {
      if (index !== this.currentFocusIndex) {
        this.doFocusRef(this.currentFocusIndex);
      }
    },
    handleDelete(index: number) {
      const currentKey = [...this.currentKey];
      if (currentKey[index] !== '') {
        currentKey[index] = '';
      } else if (index - 1 >= 0) {
        currentKey[index - 1] = '';

        this.currentFocusIndex = index - 1 < 0 ? index : index - 1;
        this.doFocusRef(this.currentFocusIndex);
      }

      this.currentKey = currentKey;
      this.$emit('input', this.combinedKey);
    },
    doFocusRef(index: number) {
      const inputRef = this.$refs[`securityInputRef${index}`] as Element[];
      if (inputRef && inputRef.length > 0) {
        (inputRef[0] as HTMLInputElement).focus();
        return true;
      }
      return false;
    },
    inputSecurityClasses(index: number) {
      return {
        active: this.currentKey[index] !== '',
        'with-dot': !this.disableMask
      };
    }
  },
  created() {
    const { currentKey } = this;

    const lengthSecurityKey = this.securityKey.length;
    for (let currentIndex = 0; currentIndex < this.length; currentIndex++) {
      currentKey.push(currentIndex < lengthSecurityKey ? this.securityKey[currentIndex] : '');
    }

    this.currentKey = currentKey;
    this.currentFocusIndex = lengthSecurityKey;
  }
});
